// import DriverMetrics from "./DriverMetrics";
// import DriverInfo from "./DriverInfo";
import TrackingMap from "./TrackingMapNew";

export default function DriverMap() {
  return (
    <section className="grid grid-cols-12 gap-4 h-[calc(100vh-15.5rem)] relative z-0 isolate">
      <div className="col-span-12  order-last lg:order-first w-full">
        <TrackingMap />
      </div>
    </section>
  );
}
